import React, { useState, useEffect } from "react";
import { Col, Row, Pagination } from "react-bootstrap";
import { Oval } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { postWithdrawRequestSeller, printReqTrans } from "store/actions";
import { Input, PaginationItem, PaginationLink } from "reactstrap";
import toastr from "toastr";
const initialFormState = {
    bankName: "",
    accountNumber: "",
    swiftCode: "",
    iban: "",
    amount: "",
    seller_id: "",
    request_type: "User"
}
export default function WithdrawFiat(props) {
    const dispatch = useDispatch();
    const { user } = useSelector((s) => s?.Login);
    const { loading, fiatTotalEarning, fiat_available_amount, withdrawals } = useSelector((s) => s?.Print)
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalAvialAmount, setTotalAvialAmount] = useState(0);
    const [form, setForm] = useState(initialFormState);
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleMaxClick = () => {
        setForm((prev) => ({
            ...prev,
            amount: Number(user?.fiat_available_amount || 0).toFixed(2),
        }));
        setErrors((prev) => ({ ...prev, amount: "" }));
    };

    useEffect(() => {
        if (user?._id) {
            setForm((p) => ({ ...p, seller_id: user?._id }))
            const getWIthdRedCallback = (res) => {
                console.log("41234123412341", res)
                setTotalAmount(res.data.fiat_total_earning)
                setTotalAvialAmount(res.data.fiat_available_amount)
            }
            console.log("fsadfasdfasdf", user?._id)
            dispatch(printReqTrans({ userId: user?._id }, getWIthdRedCallback))
        }
    }, [user])

    useEffect(() => {
        console.log("23412341234TotalEar", fiatTotalEarning)
        console.log("23412341234AvailAmoutn", fiat_available_amount)
        console.log("23412341234withdrawals", withdrawals)
        setData(withdrawals)
    }, [ withdrawals])

    const validate = () => {
        const newErrors = {};
        const { bankName, accountNumber, swiftCode, iban, amount } = form;

        if (!bankName.trim()) newErrors.bankName = "Bank name is required.";
        if (!accountNumber.trim()) newErrors.accountNumber = "Account number is required.";
        else if (!/^\d{6,20}$/.test(accountNumber)) newErrors.accountNumber = "Invalid account number.";

        if (!swiftCode.trim()) newErrors.swiftCode = "SWIFT/BIC code is required.";
        else if (!/^[A-Za-z0-9]{8,11}$/.test(swiftCode)) newErrors.swiftCode = "Invalid SWIFT/BIC code.";

        if (!iban.trim()) newErrors.iban = "IBAN is required.";
        // else if (!/^[A-Z]{2}[0-9A-Z]{13,30}$/.test(iban)) newErrors.iban = "Invalid IBAN format.";

        const available = Number(user?.fiat_available_amount || 0);
        if (!amount.trim()) newErrors.amount = "Amount is required.";
        else if (isNaN(amount) || Number(amount) <= 0) newErrors.amount = "Amount must be a positive number.";
        else if (Number(amount) > available) newErrors.amount = "Amount exceeds available balance.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;
        const withdrawCallback = (res) => {
            console.log("withdrawCallback", res)
            if (res.status ==="success") {
                toastr.success("Withdraw request added successfully.")
                const getWIthdRedCallback = (res) => {
                    console.log("41234123412341", res)
                    setTotalAmount(res.data.fiat_total_earning)
                    setTotalAvialAmount(res.data.fiat_available_amount)
                }
                dispatch(printReqTrans({ userId: user?._id }, getWIthdRedCallback))
                setForm((p) => ({
                    ...p,
                    bankName: "",
                    accountNumber: "",
                    swiftCode: "",
                    iban: "",
                    amount: "",
                    request_type: "User"
                }))

            } else {
                toastr.error(res.message)
            }
        }
        dispatch(postWithdrawRequestSeller(form, withdrawCallback))
    };


    //pagintaion

    /// pagination
    const [data, setData] = useState([])
    const [dataLength, setDataLength] = useState([])
    const [dataAfterPagination, setDataAfterPagination] = useState([])
    var [values, setValues] = useState(5)
    var [sNoValue, setSNovalue] = useState(0)
    useEffect(() => {
        var x = 0
        if (data?.length < 4) {
            x = 1
        } else {
            x = Math.ceil((data.length) / 5)
        }
        for (let i = 1; i <= x; i++) {
            if (!dataLength.includes(i)) {
                dataLength.push(i)
            }
        }
    }, [data])


    useEffect(() => {
        let arr = []
        setSNovalue(values - 5)
        for (let i = (values - 5); i < values; i++) {
            if (data[i]) {
                arr.push(data[i])
            }
        }
        setDataAfterPagination(arr)


    }, [values, data])



    const handlePagination = (val) => {
        var valu = 0
        if (val === "<<") {
            valu = 5
        }
        else if (val === "<") {
            valu = ((parseInt(values) - 5))
        }
        else if (val === ">" && (sNoValue / 5) < values) {
            valu = ((parseInt(values /5) + 1) * 5)
        }
        else if (val === ">>" && values < data.length) {
            // setSNovalue(data.length)
            valu = Math.ceil((data.length) /5) * 5
        } else {
            valu = (parseInt(val) *5)
        }
        setValues(valu)
    }
    useEffect(() => {
        setDataLength([1]);
        setValues(5)

    }, [])

    return (
        <>
            <Row>
                {(loading) &&
                    <div className='loaderBoxMiane'>
                        <Oval
                            height={80}
                            width={80}
                            color="#6C63FF"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#6C63FF"
                            strokeWidth={2}
                            strokeWidthSecondary={2}
                        />
                    </div>
                }
                <Col lg={12} className="mb-4">
                    <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
                        <h1 className="mb-0 ">Withdraw Fiat</h1>
                        <NavLink to={'../earnings'} ><button className="WithdrawFiat backgtn">Back</button></NavLink>
                    </div>
                </Col>
                <Col lg={12}>
                    <div className="withrawalBox">
                        <Row>
                            <Col className="mb-3" lg={3}>
                                <div className="amountBoxs totalmount">
                                    <h1>${Number(totalAmount).toFixed(2) || 0.00}</h1>
                                    <p>Total Earning</p>
                                </div>
                            </Col>
                            <Col className="mb-3" lg={3}>
                                <div className="amountBoxs totalwithrowal">
                                    <h1>$ { Number(totalAmount).toFixed(2)-Number(totalAvialAmount).toFixed(2) || 0.00}</h1>
                                    <p>Total Withdrawl</p>
                                </div>
                            </Col>
                            <Col className="mb-3" lg={3}>
                                <div className="amountBoxs totalbalance">
                                    <h1>$ {Number(totalAvialAmount).toFixed(2) || 0.00}</h1>
                                    <p>Total Available Balance</p>
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div className="withdrwalForm">
                                    <h2>Withdrawal Form</h2>
                                    <p>Please fill the bank details for complete the process</p>
                                    <Row className="mt-4">
                                        <Col lg={6}>
                                            <Row>
                                                <Col lg={12} className="mb-3">
                                                    <div className="form-group">
                                                        <label>Bank Name</label>
                                                        <input type="text"
                                                            name="bankName"
                                                            className={`form-control ${errors.bankName && "is-invalid"}`}
                                                            value={form.bankName}
                                                            onChange={handleChange}
                                                            placeholder="Enter Bank Name" />
                                                        {errors.bankName && <small className="text-danger">{errors.bankName}</small>}
                                                    </div>
                                                </Col>
                                                <Col lg={6} className="mb-3">
                                                    <div className="form-group">
                                                        <label>Account Number</label>
                                                        <input type="text"
                                                            name="accountNumber"
                                                            className={`form-control ${errors.accountNumber && "is-invalid"}`}
                                                            value={form.accountNumber}
                                                            placeholder="Enter Account Number"
                                                            onChange={handleChange} />
                                                        {errors.accountNumber && <small className="text-danger">{errors.accountNumber}</small>}
                                                    </div>
                                                </Col>
                                                <Col lg={6} className="mb-3">
                                                    <div className="form-group">
                                                        <label>SWIFT/BIC Code</label>
                                                        <input type="text" name="swiftCode"
                                                            className={`form-control ${errors.swiftCode && "is-invalid"}`}
                                                            value={form.swiftCode}
                                                            onChange={handleChange}
                                                            placeholder="Enter SWIFT/BIC Code" />
                                                        {errors.swiftCode && <small className="text-danger">{errors.swiftCode}</small>}
                                                    </div>
                                                </Col>
                                                <Col lg={6} className="mb-3">
                                                    <div className="form-group">
                                                        <label>IBAN</label>
                                                        <input type="text" name="iban"
                                                            className={`form-control ${errors.iban && "is-invalid"}`}
                                                            value={form.iban}
                                                            placeholder="IBAN"
                                                            onChange={handleChange} />
                                                        {errors.iban && <small className="text-danger">{errors.iban}</small>}
                                                    </div>
                                                </Col>
                                                <Col lg={6} className="mb-3">
                                                    <div className="form-group ">
                                                        <label>Amount</label>
                                                        <div className="position-relative">
                                                            <span className="dollerSymbol">$</span>
                                                            <input type="text" name="amount"
                                                                className={`form-control ps-4 ${errors.amount && "is-invalid"}`}
                                                                value={form.amount}
                                                                onChange={handleChange} placeholder="Enter Amount" />
                                                            <button className="maxBtn" onClick={handleMaxClick}>Max</button>
                                                        </div>
                                                        {errors.amount && <small className="text-danger">{errors.amount}</small>}
                                                    </div>
                                                </Col>
                                                <Col lg={6} className="mb-3">
                                                    <button onClick={handleSubmit} disabled={submitting} class="btn btn-secondary text-white fw-semibold px-2 w-100 text-center"> Submit Withdrawl Request</button>
                                                </Col>
                                            </Row>


                                        </Col>
                                    </Row>
                                </div>
                            </Col>

                            <Col lg={12}>
                                <div className="withdrwalForm">
                                    <h2>Transaction History</h2>
                                    <div className="table-responsive tableNft mt-2">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <td>Amount</td>
                                                    <td>Withdrawl Date</td>
                                                    <td>Transaction ID</td>
                                                    <td>Status</td>
                                                    {/* <td className="text-center">View</td> */}
                                                </tr>
                                            </thead>
                                            {dataAfterPagination && dataAfterPagination.length > 0 && dataAfterPagination.map((item) =>
                                                <tbody key={item?._id}>
                                                    <tr>
                                                        <td>$ {item?.withdrawal_amount}</td>
                                                        <td>{item?.created_date}</td>
                                                        <td>{item?.withdraw_track_id}</td>
                                                        <td>
                                                            <button className="statusbtt onsale p-0 text-capitalize bg-transparent">{item?.status}</button>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>

                                {dataAfterPagination.length > 0 &&
                                    <Col lg={12} className="text-end">
                                        <Pagination className="paginationNew" aria-label="Page  navigation example">
                                            {values > 5 &&
                                                <div className="d-flex align-items-center gap-2">
                                                    <PaginationItem  >
                                                        <PaginationLink
                                                            first
                                                            href="#"
                                                            onClick={() => handlePagination("<<")}
                                                        />
                                                    </PaginationItem>
                                                    <PaginationItem >
                                                        <PaginationLink
                                                            href="#"
                                                            previous
                                                            onClick={() => handlePagination("<")}
                                                        />
                                                    </PaginationItem>
                                                </div>
                                            }
                                            {dataLength && dataLength.map((item) =>
                                                <PaginationItem className={parseInt(item) === (values / 5) ? "active" : ""}  >
                                                    <PaginationLink href="#" onClick={() => handlePagination(item)}>
                                                        {item}
                                                    </PaginationLink>
                                                </PaginationItem>
                                            )}

                                            {values < data.length &&
                                                <div className="d-flex align-items-center gap-2">
                                                    <PaginationItem>
                                                        <PaginationLink
                                                            href="#"
                                                            next
                                                            onClick={() => handlePagination(">")}
                                                        />
                                                    </PaginationItem>
                                                    <PaginationItem>
                                                        <PaginationLink
                                                            href="#"
                                                            last
                                                            onClick={() => handlePagination(">>")}
                                                        />
                                                    </PaginationItem>
                                                </div>
                                            }
                                        </Pagination>
                                    </Col>}
                                </div>

       
                            </Col>

                        </Row>

                    </div>
                </Col>
            </Row>
        </>
    )
}